export enum InterviewType {
  SMS = 'SMS / Courriel',
  Telephone = 'Téléphonique / visio',
  PhysicalCip = 'Physique CIP',
  PhysicalPsy = 'Physique CIP + Psy',
  PhysicalTs = 'Physique CIP + TS',
  PhysicalTsPsy = 'Physique CIP + TS + Psy',
  PhysicalTri = 'Physique tripartite',
  PartnerContact = 'Contact partenaire',
  PhysicalPsyCo = 'Physique Psy',
  PhysicalTsOnly = 'Physique TS',
  Reception = 'Accueil',
  CaseFollowUp = 'Suivi de dossier',
}

export const labelsByInterviewType: Map<InterviewType, string> = new Map<InterviewType, string>(
  Object.keys(InterviewType).map((x: string) => [x, InterviewType[x]] as [InterviewType, string]),
);
